<template>
  <v-text-field v-on="importListeners" v-bind="$attrs" v-model="displayValue" v-mask="displayMask" />
</template>

<script>
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  props: {
    mask: {
      type: [String, Array],
      required: true
    },
    value: String
  },
  data() {
    return {
      defaultTokens: ["#", "X", "S", "A", "a", "!"]
    };
  },
  computed: {
    importListeners() {
      let listeners = {};
      for (const key in this.$listeners) {
        if (key !== "input") {
          listeners[key] = this.$listeners[key];
        }
      }
      return listeners;
    },
    displayValue: {
      get() {
        return this.maskvalue(this.value);
      },
      set(val) {
        let newVal = "";        
        if (val) {
          newVal = this.unmask(val);
        }
        this.$emit("input", newVal);
      }
    },
    displayMask() {
      return this.defineMask(this.value);
    }
  },
  created() {},
  methods: {
    //Retorna apenas Alfanumerico da String
    clearMask(valor) {
      if (!valor) return "";
      return valor.replace(/[^a-z0-9]/gi, "");
    },

    //Retorna apenas os valores definidos nos tokens default. Ex: #.#.# -> Retorna ###
    unmaskMask(mascara) {
      let novaMascara = "";
      for (let x = 0; x < mascara.length; x++) {
        if (this.defaultTokens.findIndex(y => y === mascara[x]) !== -1) {
          novaMascara += mascara[x];
        }
      }

      return novaMascara;
    },

    //Caso a prop mask for um Array é verificado qual a mascara será utilizada de acordo com as informações que o usuário está digitando.
    defineMask(valor) {
      if (Array.isArray(this.mask)) {
        let currentMask = "";
        let currentValue = valor || "";
        this._.forEach(this.mask, value => {
          let mascara = this.unmaskMask(value);
          if (!currentMask) currentMask = value;
          else {
            if (this.unmaskMask(currentMask).length < currentValue.length) {
              if (this.unmaskMask(currentMask).length < mascara.length) {
                currentMask = value;
              }
            }
          }
        });
        return currentMask;
      }
      return this.mask;
    },

    //Mascara um valor para ser mostrado no input
    maskvalue(unmaskedValue) {
      if (!unmaskedValue) return "";

      let maskedValue = "";
      let isToken;
      let foundKey = 0;

      for (let i = 0; i < unmaskedValue.length; i++) {
        isToken = false;
        for (let j = 0; j < this.defaultTokens.length; j++) {
          if (this.displayMask[i + foundKey] == this.defaultTokens[j]) {
            isToken = true;
          }
        }
        if (!isToken) {
          maskedValue += this.displayMask[i + foundKey++];
        }
        maskedValue += unmaskedValue[i];
      }

      return maskedValue;
    },

    //Retira a mascara para ser gravado no model
    unmask(maskedValue) {
      let unmaskedValue = "";
      let isToken;
      let valorSemMascara = this.clearMask(maskedValue);
      let mask = this.defineMask(valorSemMascara);

      for (let i = 0; i < maskedValue.length; i++) {
        isToken = false;
        for (let j = 0; j < this.defaultTokens.length; j++) {
          if (mask[i] === this.defaultTokens[j]) {
            isToken = true;
          }
        }
        if (isToken) {
          unmaskedValue += maskedValue[i];
        }
      }

      return unmaskedValue;
    }
  }
};
</script>